import type { DropDownItem } from '../elements/SelectDropdown';

export interface FormHelpOption extends DropDownItem {
  key: string;
  valueOverride: string;
}

export const FORM_HELP_OPTIONS: FormHelpOption[] = [
  {
    en: 'Recruiting Services',
    key: 'Form_Selection_Recruiting',
    valueOverride: 'recruit_radio',
    fr: 'Services de recrutement',
    de: 'Personalbeschaffung',
    es: 'Servicios de reclutamiento',
    nl: 'Wervingsdiensten',
  },
  {
    en: 'Hire and pay employees via employer of record',
    key: 'Form_Selection_GEO',
    valueOverride: 'hire_radio',
    fr: 'Recrutez et payez vos employés via le portage salarial',
    de: 'Beschäftigung und Bezahlung der Mitarbeitenden durch einen Employer of Record',
    es: 'Contrata y paga a los empleados a través de Employer of Record',
    nl: 'Werknemers recruiten name betalen via geregistreerde werkgever',
  },
  {
    en: 'Paying Contractors',
    valueOverride: 'contractor_radio',
    key: 'Form_Selection_Contractors',
  },
  {
    en: 'Payroll for international workforces',
    valueOverride: 'pay_radio',
    key: 'Form_Selection_GMP',
    fr: 'Gestion de la paie pour vos équipes internationales',
    de: 'Payroll für eine internationale Belegschaft',
    es: 'Nómina para trabajadores internacionales',
    nl: 'Loonlijst voor internationale werknemers',
  },
  {
    en: 'Setup, registration, taxes or accounting for international entities',
    valueOverride: 'registration_radio',
    key: 'Form_Selection_Manage',
    fr: 'Configuration, enregistrement, taxes ou comptabilité pour les entités internationales',
    de: 'Einrichtung, Registrierung, Steuern oder Buchhaltung für internationale Unternehmen',
    es: 'Constitución, registro, impuestos o contabilidad para entidades internacionales',
    nl: 'Installatie, registratie, belastingen of boekhouding voor internationale entiteiten',
  },
  {
    en: 'Visas, benefits or other HR outsourcing',
    valueOverride: 'outsourcing_radio',
    key: 'Form_Selection_Manage',
    fr: 'Visas, avantages ou autre HR outsourcing',
    de: 'Visas, Vorteile oder andere HR-Outsourcing',
    es: 'Visas, beneficios o outsourcing de HR',
    nl: 'Visas, voordelen of andere HR-outsourcing',
  },
  {
    en: "I'm interested in multiple solutions/I'm not sure what I need",
    valueOverride: 'dk_radio',
    key: 'Form_Selection_Dont_Know',
    fr: 'Je suis intéressé par plusieurs solutions/Je ne sais pas ce que je cherche',
    de: 'Ich bin an mehreren Lösungen interessiert/Ich bin nicht sicher, was ich brauche',
    es: 'Estoy interesado en varias soluciones/No estoy seguro de lo que necesito',
    nl: 'Ik ben geïnteresseerd in meerdere oplossingen/Ik weet niet wat ik nodig heb',
  },
  {
    en: "I'm a current client and need support",
    valueOverride: 'other_radio',
    key: 'Form_Selection_Support',
    fr: "Je suis un client actuel et j'ai besoin d'aide",
    de: 'Ich bin ein aktueller Kunde und brauche Unterstützung',
    es: 'Soy un cliente actual y necesito ayuda',
    nl: 'Ik ben een huidige klant en heb hulp nodig',
  },
];

export const FORM_HELP_OVERRIDE_MAP: Record<string, string> = {
  recruit_radio: 'recruit_tf',
  hire_radio: 'hire_tf',
  contractor_radio: 'contractor_tf',
  pay_radio: 'pay_tf',
  outsourcing_radio: 'manage_tf',
  registration_radio: 'manage_tf',
  dk_radio: 'dk_tf',
  other_radio: 'other_tf',
};

export const FORM_HELP_SUPPORT_OPTIONS = [
  {
    en: 'Global Employment Outsourcing (GEO)',
    key: 'Global Employment Outsourcing GEO',
    valueOverride: 'geo_radio',
    fr: 'Global Employment Outsourcing (GEO)',
    de: 'Global Employment Outsourcing (GEO)',
    es: 'Global Employment Outsourcing (GEO)',
    nl: 'Global Employment Outsourcing (GEO)',
  },
  {
    en: 'Global Managed Payroll',
    key: 'Global Managed Payroll',
    valueOverride: 'pay_radio',
    fr: 'Global Managed Payroll',
    de: 'Global Managed Payroll',
    es: 'Global Managed Payroll',
    nl: 'Global Managed Payroll',
  },
  {
    en: 'Setup, registration, taxes or accounting for international entities',
    key: 'Managed Solutions',
    valueOverride: 'registration_radio',
    fr: 'Configuration, enregistrement, taxes ou comptabilité pour les entités internationales',
    de: 'Einrichtung, Registrierung, Steuern oder Buchhaltung für internationale Unternehmen',
    es: 'Constitución, registro, impuestos o contabilidad para entidades internacionales',
    nl: 'Installatie, registratie, belastingen of boekhouding voor internationale entiteiten',
  },
  {
    en: 'Visas, benefits or other HR outsourcing',
    key: 'Managed Solutions',
    valueOverride: 'outsourcing_radio',
    fr: 'Visas, avantages sociaux ou autre sous-traitance RH',
    de: 'Visa, Sozialleistungen oder anderes HR-Outsourcing',
    es: 'Visas, beneficios u otra subcontratación de recursos humanos',
    nl: 'Visa, secundaire arbeidsvoorwaarden of andere HR-outsourcing',
  },
  {
    en: "I'm interested in multiple solutions/I'm not sure what I need",
    key: "I Don't Know",
    valueOverride: `I Don't Know`,
    fr: "Je suis intéressé par plusieurs solutions/Je ne suis pas sûr de ce dont j'ai besoin",
    de: 'Ich interessiere mich für mehrere Lösungen/ich bin mir nicht sicher, was ich brauche',
    es: 'Estoy interesado name múltiples soluciones/No estoy seguro de lo que necesito',
    nl: 'Ik ben geïnteresseerd in meerdere oplossingen/ik weet niet zeker wat ik nodig heb',
  },
];

export const FORM_HELP_SUPPORT_OVERRIDE_MAP: Record<string, string> = {
  geo_radio: 'Global Employment Outsourcing GEO',
  pay_radio: 'Global Managed Payroll',
  registration_radio: 'Managed Solution',
  outsourcing_radio: 'Managed Solution',
  dk_radio: "I Don't Know",
};
